export default [
    {
        path: 'shop',
        name: 'guideShop',
        meta: {
            title: 'GuideShop',
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "combind" */'@/views/guide/Shop.vue'),
    },
];
